import { useQueryClient, useMutation } from "react-query";

export default function useOptimisticDelete(key, fn){

    const queryClient = useQueryClient();

    return useMutation(fn, {

        onMutate: async id => {

            await queryClient.cancelQueries({ queryKey: [key] })

            const previous = queryClient.getQueryData([key])

            queryClient.setQueryData([key], old => {

                let copy = [...old];
                copy = copy.filter(i => i.id !== id)

                return copy;
            })

            return { previous }
        },

        onError: (e, data, context) => {
            console.log(e, data)
            queryClient.setQueryData([key], context.previous)
        },

        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [key] })
        },
    })


}
